import { queryKeys } from '@/lib/query-keys';
import { apiClient } from '@borradh-workspace/api-client';
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { toast } from 'sonner';
import { z } from 'zod';

// No `country`: eligibility no longer depends on the clinic's own location —
// the sender for any given message is resolved from the RECIPIENT's own
// number at dispatch time, not stored per org.
const schema = z.object({
  visible: z.boolean(),
  enabled: z.boolean(),
  available: z.boolean(),
});

export function useSmsChatbot() {
  const client = useQueryClient();
  const queryKey = queryKeys.campaigns.smsChatbot();
  const query = useQuery({
    queryKey,
    queryFn: () => apiClient.get('campaigns/sms-chatbot', { schema }),
  });
  const mutation = useMutation({
    mutationFn: (enabled: boolean) =>
      apiClient.put('campaigns/sms-chatbot', { enabled }, { schema }),
    onSuccess: (config) => {
      client.setQueryData(queryKey, config);
      void client.invalidateQueries({
        queryKey: queryKeys.campaigns.smsNumber(),
      });
      toast.success(
        config.enabled ? 'SMS assistant enabled' : 'SMS assistant disabled'
      );
    },
    onError: (error: Error) =>
      toast.error(error.message || 'Could not update SMS assistant'),
  });
  return { query, mutation };
}
